import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { axiosRegisterInstance } from "../../../../axios.js";

import {
  INSERT_REGISTER_USER,
  INSERT_ROLE_SETTINGS,
  REGISTRATION_OTP_PHONE_SEND,
  REGISTRATION_OTP_EMAIL_SEND,
  VALIDATE_REGISTRATION_OTP,
  GET_SF_USER_DETAILS,
  CREATE_USER_ACCOUNT,
  RESET_PASSWORD,
  FORGOT_PASSWORD_OTP_EMAIL_SEND,
  RESET_FORGOT_PASSWORD,
  CREATE_ADMIN_USER_ACCOUNT,
  GET_SF_BUILDER_DETAILS,
} from "../../../../Urls.js";

const initialState = {
  insertRegisterUserData: { data: [], loader: false },
  triggerPhoneOtpData: { data: {}, loader: false },
  phoneOtpVerfication: { data: {}, loader: false },
  triggerEmailOtpData: { data: {}, loader: false },
  emailOtpVerfication: { data: {}, loader: false },
  resetPassordData: { data: {}, loader: false },
  getSalesForceData: { data: {}, loader: false },
  sfBuilderData: { data: {}, loader: false },
};

export const verifyotpdetails = createAsyncThunk(
  "app/pmreg/validate",
  async (reqData) => {
    const response = await axiosRegisterInstance.post(
      `/api/v1/pmreg/validate-otp?trackingId=${reqData.tracking_id}`,
      {
        ...reqData,
      },
    );
    return response;
  },
);

export const saveUserDetails = createAsyncThunk(
  "app/registration/saveUserDetails",
  async (payload) => {
    const response = await axiosRegisterInstance.post(CREATE_USER_ACCOUNT, {
      ...payload,
    });
    return response;
  },
);

export const sendOtpEmail = createAsyncThunk(
  "app/otp/sendOtpEmail",
  async (reqData) => {
    const response = await axiosRegisterInstance.get(
      `/api/v1/pmreg/send-otp-email?emailId=${reqData.emailId}&trackingId=${reqData.tracking_id}`,
    );
    return response;
  },
);
export const sendOtpPhone = createAsyncThunk(
  "app/inert/sendOtpPhone",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(`/api/v1/pmreg/phone-otp-sms?phoneNumber=${reqData.phoneNumber}&trackingId=${reqData.tracking_id}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const encryptText = createAsyncThunk(
  "app/pmreg/encryptText",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(
        `/api/v1/pmreg/encrpt-text?text=${reqData.text}`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const getPaymentLinkDetails = createAsyncThunk(
  "app/pmreg/getPaymentLinkDetails",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.get(
        `/api/v1/pmreg/link-encrpt?text=${reqData.text}`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const updatePaymentLinkDetails = createAsyncThunk(
  "app/pmreg/updatePaymentLinkDetails",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(
        `/api/v1/pmreg/link-encrpt?text=${reqData.text}&status=${reqData.status}`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const userDetailsFromencryptText = createAsyncThunk(
  "app/pmreg/userDetailsencryptText",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(
        `/api/v1/pmreg/user-details-from-encrpt?text=${reqData.text}&type=PMREGISTER`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const decryptText = createAsyncThunk(
  "app/pmreg/decryptText",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(
        `/api/v1/pmreg/decrypt-text?text=${reqData.text}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const decryText = createAsyncThunk(
  "app/camp/decryptText",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await axiosRegisterInstance.post(
        `/api/v1/campaign/decrypt?text=${reqData.text}`
      );

      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const resetPassword = createAsyncThunk(
  "app/customer/resetPassword",
  async (payload) => {
    const response = await axios.post(RESET_PASSWORD, { ...payload });
    return response;
  },
);

export const getPayemntGateWayUnAuth = createAsyncThunk(
  'app/get/unauth/payementGateWay',
  async payload => {
    const response = await axios.post(`/api/v1/pmreg/save-profile?crm_customer_id=${payload.crm_customer_id}&service_account_number=${payload.crm_service_account_no}&billing_account_number=${payload.crm_billing_account_no}&parent_account_number=${payload.parent_account_number}&trackingId=${payload.tracking_id}&newToken=${payload.newToken}`);
    return response;
  }
);

export const registerUserDetailSlice = createSlice({
  name: "app/registerUserDetailSlice",
  initialState,
  reducers: {
    setinsertRegisterUserData: (state, action) => {
      state.insertRegisterUserData = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(resetPassword.pending, (state) => {
        state.resetPassordData.loader = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPassordData.loader = false;
        state.resetPassordData.data = action?.payload?.data?.data;
      })
      .addCase(resetPassword.rejected, (state) => {
        state.resetPassordData.loader = false;
      });
  },
});

export const { setSelectedAccount, addServiceTickets, setViewServiceTicket } =
  registerUserDetailSlice.actions;

export default registerUserDetailSlice.reducer;
